import { render, staticRenderFns } from "./teacher-add-form.vue?vue&type=template&id=0fe410c5&scoped=true"
import script from "./teacher-add-form.vue?vue&type=script&lang=js"
export * from "./teacher-add-form.vue?vue&type=script&lang=js"
import style0 from "./teacher-add-form.vue?vue&type=style&index=0&id=0fe410c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe410c5",
  null
  
)

export default component.exports